import { render, staticRenderFns } from "./CloseIcon.vue?vue&type=template&id=54d9d7fc&scoped=true&"
import script from "./CloseIcon.vue?vue&type=script&lang=js&"
export * from "./CloseIcon.vue?vue&type=script&lang=js&"
import style0 from "./CloseIcon.vue?vue&type=style&index=0&id=54d9d7fc&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d9d7fc",
  null
  
)

export default component.exports